import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
	
	$stateProvider.states(['company.sharing-center.shared-passwords.manage.share', 'company.sharing-center.shared-authenticators.manage.share','company.sharing-center.shared-notes.manage.share'], {
		url: '/share', 
		params: { sharedAccount: {} },
		component: 'companySharingCenterShare',
		resolve: {users, sharedLabels}
	});
}

/** @ngInject */
function users(SharedAccountsService,  $stateParams,isNote) {
	if(isNote){
		return SharedAccountsService.getAllCompanyNotesUsers({
                companyId: $stateParams.companyId,
                id: $stateParams.sharedAccountId,
            }, {}).$promise.then((sharedUsersList) => {
                return sharedUsersList;
            });
	}
	return SharedAccountsService.getSaaspassUsersByCorporateServiceAccountId({
		companyId: $stateParams.companyId,
		id: $stateParams.sharedAccountId,
	}, {}).$promise.then(({ sharedUsersList }) => {
		return sharedUsersList;
	});
}

/** @ngInject */
function sharedLabels(SharedAccountsService, $stateParams, isNote) {
	if (isNote) {
		return SharedAccountsService.getSharedLabelsByCorporateNoteId({
			companyId: $stateParams.companyId,
			id: $stateParams.sharedAccountId,
		}, {}).$promise.then(labels => labels.map((label) => (
			updateLabelDTO(label)))
		)
	} else {
		return SharedAccountsService.getSharedLabelsByCorporateServiceAccountId({
			companyId: $stateParams.companyId,
			id: $stateParams.sharedAccountId,
		}, {}).$promise.then(labels => labels.map((label) => (
			updateLabelDTO(label)))
		)
	}
}

function updateLabelDTO(label) {
    let className = '';
    let sref = '';
    if (label.isCustom) {
    	className = 'sp_colorBlueLink fa fa-user-circle-o';
    	sref = 'company.user-directories.saaspass-users.user-labels({userLabelId:' + label.id.toString() + '})';
    } else {
    	if (label.name === 'ALL_USERS') {
    		className = 'sp_colorBlueLink fa fa-users';
    		sref = 'company.user-directories.saaspass-users.all-users';
    	} else if (label.name === 'ADMINISTRATORS') {
    		className = 'sp_colorBlueLink fa fa-user-plus';
    		sref = 'company.user-directories.saaspass-users.administrators-developers';
    	} else if (label.name === 'MOBILE_APP_USERS') {
    		className = 'sp_colorBlueLink fa fa-mobile-alt';
    		sref = 'company.user-directories.saaspass-users.regular-saaspass-app-users';
    	} else if (label.name === 'HARD_TOKEN_USERS') {
    		className = 'sp_colorBlueLink fa fa-calculator';
    		sref = 'company.user-directories.saaspass-users.hard-token-users';
    	} else if (label.name === 'SMS_USERS') {
    		className = 'sp_colorBlueLink fa fa-comment';
    		sref = 'company.user-directories.saaspass-users.sms-users';
    	}
    }
    return {...label, className, sref };
}






// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/share/share.state.js